import * as React from 'react';

import useClientList, { ClientListOptions } from 'hooks/useClientList';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';

import FormInput from '../../../components/FormInput';
import FormInputSelect from '../../../components/FormInputSelect';

interface Props {
  change: (field: string, value: any) => void;
}

const ClientOptionsSuperAdmin: React.FC<Props> = ({ change }) => {
  const { t } = useTranslation();
  const [clientOptions, setClientOptions] = React.useState<ClientListOptions[]>(
    [],
  );

  const clientOptionsData = useClientList();

  React.useEffect(() => {
    if (clientOptionsData) {
      setClientOptions(clientOptionsData);
    }
  }, [clientOptionsData]);

  return (
    <Field
      key={clientOptions.length}
      name="client_name"
      component={FormInput}
      inputComponent={FormInputSelect}
      customLabel
      labelText={t('reports.clientLabel')}
      options={clientOptions}
      isSearchable
      hideSelectedOptions={false}
      placeholder={t('reports.clientPlaceholder')}
      closeMenuOnSelect={true}
      required
      value={(val) => val.value}
      onChange={(_, newValue) => {
        change('client_name', newValue.value);
      }}
    />
  );
};

export default ClientOptionsSuperAdmin;
